// extracted by mini-css-extract-plugin
module.exports = {"header":"_3uDB1QfU","headerInner":"_31D1pETg","body":"_15nUkRTA","button":"eBdXh8oc"};